import autobind from 'react-autobind'
import React, { Component } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import RequestMessage from './RequestMessage';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';

const striptags = (str) => {
    return str.replace(/<\/?[^>]+>/g, '')
}
export default class RequestListItem extends Component {

    constructor(props) {
        super(props);
        autobind(this);

        this.state = {
            newRequestModalOpen: false,
            messageState: EditorState.createEmpty(),
            messageMarkup: '',
            isReplying: false
        }
    }

    toggleNewRequestModalOpen(myUnreadMessages) {

        if (!this.state.newRequestModalOpen && this.props.readMessages) {
            this.props.readMessages(myUnreadMessages)
        }

        this.setState({
            newRequestModalOpen: !this.state.newRequestModalOpen
        })
    }

    onMessageStateChange(messageState) {

        this.setState({
            messageState: messageState,
            messageMarkup: draftToHtml(convertToRaw(messageState.getCurrentContent()))
        })

    }

    onSendButtonClick() {
        const { product, notification, messageType, conversationPartner } = this.props
        this.props.onSendButtonClick(conversationPartner.id, product ? { type: 'product', id: product._id } : { type: 'notification', id: notification._id }, messageType ? messageType._id : null, this.state.messageMarkup)
        this.setState({
            isReplying: false
        })
    }

    onReplyButtonClick() {
        this.setState({
            isReplying: true
        })
    }

    onCancelButtonClick() {
        this.setState({
            isReplying: false
        })
    }

    renderReply() {
        if (this.props.reply) {
            return (
                <div>
                    {this.state.isReplying ? <Editor editorState={this.state.messageState} toolbarClassName="wysiwyg-toolbar" wrapperClassName="wysiwyg-wrapper" editorClassName="wysiwyg-editor mb-5" onEditorStateChange={this.onMessageStateChange} /> : ''}
                    <div className="mt-0 mr-0 mb-px-30 ml-px-145">
                        {this.state.isReplying ? (
                            <div>
                                <button className="btn btn-rounded btn-space btn-primary btn-md-lateral-space mr-3" onClick={this.onSendButtonClick}>Send</button>
                                <button className="btn btn-rounded btn-space btn-secondary btn-md-lateral-space" onClick={this.onCancelButtonClick}>Cancel</button>
                            </div>
                        ) : <button className="btn btn-rounded btn-space btn-primary btn-md-lateral-space" onClick={this.onReplyButtonClick}>Reply</button>}
                    </div>
                </div>)
        } else {
            return;
        }
    }

    getPosition(previousFromId, currentFromId, previousPosition) {

        if (!previousFromId) return 'left'

        if (previousFromId === currentFromId)
            return previousPosition

        if (previousFromId !== currentFromId) {
            if (previousPosition === 'left') {
                return 'right'
            } else {
                return 'left'
            }
        }

    }

    getImage() {
        const { product, notification } = this.props

        if (product) {
            return <img src={product.productPath} className="product-image" alt="Product" />
        } else if (notification) {
            return <img src={notification.picture} className="product-image" alt="Product" />
        }
    }

    getLargeImage() {
        const { product, notification } = this.props

        if (product) {
            return <img src={this.props.product.productPath} className="request-product-image" alt="" />
        } else if (notification) {
            return <img src={this.props.notification.picture} className="request-product-image" alt="" />
        }
    }

    getCategory() {
        const { product, notification } = this.props

        if (product) {
            return product.category.name
        } else if (notification) {
            return notification.category.name
        }
    }

    getName() {

        const { product, notification } = this.props

        if (product) {
            return product.name
        } else if (notification) {
            return notification.locationName
        }
    }

    render() {

        const sortedMessages = this.props.messages.sort((a, b) => a.createdAt === b.createdAt ? 0 : (a.createdAt > b.createdAt ? -1 :  1))
            , latestMessage = sortedMessages[0]
            , messageTitle = sortedMessages.find(m => m.title).title
            , latestMessageText = striptags(latestMessage.message)
        const date = new Date(latestMessage.createdAt)
        const formatedDate = date.toLocaleDateString('en-us', { day: 'numeric', month: 'long', year: 'numeric' });
        const formatedTime = date.toLocaleTimeString('en-us', { hour: 'numeric', minute: 'numeric' });
        let previousFromId = null
        let position = null

        const messagesComponents = sortedMessages.map((message, index) => {
            position = this.getPosition(previousFromId, message.from.id, position)
            previousFromId = message.from.id
            return <RequestMessage key={'requestMessage_' + index} userImagePath={message.from.picturePath} date={message.createdAt} message={message.message} position={position} />
        })
            , myUnreadMessages = this.props.messages.filter(m => m.to.id === this.props.user._id && !m.read)
            , haveSomeUnread = myUnreadMessages.length > 0


        return (
            <div>
                <div className={"items-list-item " + (haveSomeUnread ? 'unread' : '')}>
                    <div className="list-item-index">
                        {this.props.index}
                    </div>
                    <div className="list-item-1 list-item-request hover" onClick={() => { this.toggleNewRequestModalOpen(myUnreadMessages) }}>
                        <div className="request-details ellipsis">
                            <span className="name">{messageTitle}</span>
                            <span className="description ellipsis">
                                {latestMessageText}
                            </span>
                        </div>
                    </div>
                    <div className="list-item-2 list-item-product hover" onClick={() => { this.toggleNewRequestModalOpen(myUnreadMessages) }}>
                        <div className="product-image-wrapper">
                            {this.getImage()}
                        </div>
                        <div className="product-details">
                            <span className="name">{this.getName()}</span>
                            <span className="description">
                                {this.getCategory()}
                            </span>
                        </div>
                    </div>
                    <div className="list-item-3 list-item-user hover" onClick={() => { this.toggleNewRequestModalOpen(myUnreadMessages) }}>
                        <img src={this.props.userImagePath} className="user-avatar" alt="Avatar" />
                        <span className="user-name ellipsis">{this.props.conversationPartner.name ? this.props.conversationPartner.name : this.props.conversationPartner.email ? this.props.conversationPartner.email : 'Anonymous'}</span>
                    </div>
                    <div className="list-item-4 list-item-date hover" onClick={() => { this.toggleNewRequestModalOpen(myUnreadMessages) }}>
                        <span className="date">{formatedDate}</span>
                        <span className="time">{formatedTime}</span>
                    </div>

                    {this.props.onRequestDelete ? (<div className={'list-item-5 list-item-actions' + (this.props.reply ? '' : ' justify-content-center')}>
                        {this.props.reply ? (<span className="ar-icon s7-back" onClick={() => { this.toggleNewRequestModalOpen(myUnreadMessages) }}></span>) : null}
                        <span className="ar-icon s7-trash" onClick={() => { this.props.onRequestDelete(this.props.messages) }}></span>
                    </div>) : null}

                </div>

                <Modal isOpen={this.state.newRequestModalOpen} toggle={this.toggleNewRequestModalOpen} className="modal-md">
                    <ModalHeader>
                        <span onClick={this.toggleNewRequestModalOpen} className="s7-close modal-close"></span>
                    </ModalHeader>
                    <ModalBody className="pt-0">
                        <div className="email-head-sender">
                            <div className="avatar"><img src={this.props.userImagePath} alt="Avatar" /></div>
                            <div className="sender">{this.props.conversationPartner.name ? this.props.conversationPartner.name : 'Anonymous'}</div>
                        </div>

                        <div className="request-product">
                            {this.getLargeImage()}
                            <div className="d-flex flex-column">
                                <h2 className="request-product-name">{this.getName()}</h2>
                                <span className="request-product-category">{this.getCategory()}</span>
                            </div>
                        </div>

                        {this.renderReply()}

                        <ul className="timeline timeline-variant timeline-requests">
                            {messagesComponents}
                        </ul>
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Request/RequestListItem.js